module.exports = __webpack_public_path__ + "static/media/myra.d55f569b.svg";